import axios from "axios";
import { getUnitApiBaseFour, SUB_URL_wash } from "../BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) {
    throw new Error("unit_code missing");
  }
  return unitCode;
};

const GetBinService = {
  ViewBinbyId: async (bin_id) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("bin_id", bin_id || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_wash.view_bin}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching bin by id:", error);

      return {
        status: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch bin",
        data: [],
      };
    }
  },
};

export default GetBinService;